var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    [
      _c(
        "el-header",
        {
          ref: "header",
          staticClass: "header",
          staticStyle: { height: "auto", "margin-bottom": "10px" },
        },
        [
          _c(
            "el-form",
            {
              ref: "searchFormRef",
              staticClass: "demo-form-inline",
              attrs: { inline: true, model: _vm.searchForm },
              nativeOn: {
                keydown: function ($event) {
                  if (
                    !$event.type.indexOf("key") &&
                    _vm._k($event.keyCode, "enter", 13, $event.key, "Enter")
                  ) {
                    return null
                  }
                  return _vm.handleSearchBtn.apply(null, arguments)
                },
              },
            },
            [
              _c(
                "div",
                { attrs: { id: "searchBox" } },
                [
                  _c(
                    "el-form-item",
                    { attrs: { prop: "xhname" } },
                    [
                      _c(
                        "el-select",
                        {
                          ref: "selectRef",
                          staticClass: "model-select",
                          staticStyle: { "margin-bottom": "10px" },
                          attrs: {
                            filterable: "",
                            remote: "",
                            "popper-append-to-body": "",
                            "reserve-keyword": "",
                            "automatic-dropdown": true,
                            "default-first-option": true,
                            placeholder: "请输入轴承型号",
                            "remote-method": _vm.remoteMethod,
                            loading: _vm.loading,
                          },
                          on: { change: _vm.handleChange },
                          model: {
                            value: _vm.keyword,
                            callback: function ($$v) {
                              _vm.keyword = $$v
                            },
                            expression: "keyword",
                          },
                        },
                        _vm._l(_vm.options, function (item) {
                          return _c("el-option", {
                            key: item.value,
                            attrs: { label: item.label, value: item.value },
                          })
                        }),
                        1
                      ),
                    ],
                    1
                  ),
                ],
                1
              ),
              _c(
                "el-form-item",
                [
                  _c(
                    "el-button",
                    {
                      staticStyle: { "margin-left": "10px" },
                      attrs: { type: "text", id: "closeSearchBtn" },
                      on: { click: _vm.closeSearch },
                    },
                    [
                      _vm._v(" " + _vm._s(_vm.word) + " "),
                      _c("i", {
                        class: _vm.showAll
                          ? "el-icon-arrow-up "
                          : "el-icon-arrow-down",
                      }),
                    ]
                  ),
                  _c(
                    "el-button",
                    {
                      attrs: {
                        type: "primary",
                        size: "small",
                        icon: "el-icon-search",
                      },
                      on: {
                        click: function ($event) {
                          return _vm.handleSearchBtn()
                        },
                      },
                    },
                    [_vm._v("搜索 ")]
                  ),
                  _c(
                    "el-button",
                    {
                      attrs: { size: "small", icon: "el-icon-refresh" },
                      on: { click: _vm.handleResetBtn },
                    },
                    [_vm._v("重置")]
                  ),
                ],
                1
              ),
            ],
            1
          ),
        ],
        1
      ),
      _c(
        "div",
        { staticClass: "custom-table search-table" },
        [
          _c(
            "el-table",
            {
              staticClass: "customer-table",
              attrs: {
                border: "",
                fit: "",
                "highlight-current-row": "",
                data: _vm.list,
              },
            },
            [
              _c("el-table-column", {
                attrs: { label: "序号", prop: "" },
                scopedSlots: _vm._u([
                  {
                    key: "default",
                    fn: function (scope) {
                      return [_vm._v(" " + _vm._s(scope.$index + 1) + " ")]
                    },
                  },
                ]),
              }),
              _c("el-table-column", {
                attrs: { label: "订单号", prop: "orderid" },
              }),
              _c("el-table-column", {
                attrs: { label: "型号", prop: "xhname" },
              }),
              _c("el-table-column", {
                attrs: { label: "品牌", prop: "source" },
              }),
              _c("el-table-column", { attrs: { label: "数量", prop: "num" } }),
              _c("el-table-column", {
                attrs: { label: "单价", prop: "price" },
              }),
              _c("el-table-column", {
                attrs: { label: "总价", prop: "zprice" },
              }),
              _c("el-table-column", { attrs: { label: "货期", prop: "hq" } }),
              _c("el-table-column", {
                attrs: { label: "是否含税", prop: "kpzt" },
              }),
              _c("el-table-column", {
                attrs: { label: "负责人", prop: "rname" },
              }),
            ],
            1
          ),
          _c("el-pagination", {
            staticStyle: { "margin-top": "14px", "margin-bottom": "14px" },
            attrs: {
              "current-page": _vm.selectPage.pageNum,
              "page-sizes": [20, 50, 100, 200],
              "page-size": _vm.selectPage.pageSize,
              background: "",
              layout: "total, sizes, prev, pager, next, jumper",
              total: _vm.allNum,
            },
            on: {
              "size-change": _vm.pageSizeChange,
              "current-change": _vm.pageCurrentChange,
            },
          }),
        ],
        1
      ),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }